import {useLanding} from '../../store/landing';
import {CategoryIconItem} from "./CategoryItemIcon";
import Tires from '../../assets/tires.jpg';

const CategoryIconCarouselSkeleton = () => (
    <>
        <div className="skeleton h-8 w-48 mb-6"/>
        <div className="bg-white rounded-3xl border border-base-200 shadow-sm p-6 mb-12">
            <div className="flex gap-6 overflow-x-auto pb-4 no-scrollbar">
                {Array.from({length: 8}).map((_, i) => (
                    <div key={i} className="flex flex-col items-center gap-2 shrink-0">
                        <div className="skeleton w-20 h-20 rounded-full"/>
                        <div className="skeleton h-3 w-16"/>
                    </div>
                ))}
            </div>
        </div>
    </>
);

export const CategoryIconCarousel = ({loading}) => {
    const {shopByCategory} = useLanding();

    if (loading) return <CategoryIconCarouselSkeleton/>;
    if (!Array.isArray(shopByCategory) || shopByCategory.length === 0) return null;
    return (
        <>
            <h2 className="text-2xl font-black pt-dark-blue mb-6">Shop by Category</h2>
            <div className="bg-white rounded-3xl border border-base-200 shadow-sm p-6 mb-12">
                <div className="relative">
                    <div className="flex gap-6 overflow-x-auto pb-4 no-scrollbar scroll-smooth">
                        <CategoryIconItem target="_blank" name="Tires" href="https://paytomorrow.tireagent.com/finance"
                                          src={Tires}/>
                        {shopByCategory.slice(0, 11).map((cat, idx) => (
                            <CategoryIconItem
                                key={idx}
                                name={cat.name}
                                src={cat.image || cat.imageUrl}
                                href={`/product-category/${cat.slug}?sort=customerReviewCount.desc`}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};
